import {
  STATUS_CAMPAIGN_ENUM_ACTIVE,
  STATUS_CAMPAIGN_ENUM_ARCHIVE,
  STATUS_CAMPAIGN_ENUM_COMPLETED,
  STATUS_CAMPAIGN_ENUM_DRAFT,
  CAMPAIGN_INTERNAL_STATUSES,
} from '../../shared/constants'

export const COLORS = ['#1967D2', '#004360', '#E4A23F', '#32935A', '#C4C4C4']
export const TITLES = {
  totalFlyersDistributed: 'Flyers distributed',
  totalHardCosts: 'Hard Costs',
  totalScans: 'Scans',
  totalPrintingCost: 'Printing costs',
  totalDistributionCost: 'Distribution costs',
  totalPermitCost: 'Permit costs',
  totalBonusCost: 'Bonus costs',
  totalMissionsCount: 'Missions',
}
export const DEFAULT_SELECTED_METRICS = [
  'totalFlyersDistributed',
  'totalHardCosts',
  'totalDistributionCost',
  'totalPrintingCost',
  'totalBonusCost',
]
export const POPOVER_MENU_ITEMS = [
  { label: 'Export in a CSV', value: 'export' },
]

export const CSV_HEADERS = {
  name: 'Name',
  missionType: 'Type',
  readableStatus: 'Status',
  flyersDistributed: 'Flyers distributed',
  hardCosts: 'Hard Costs',
  distributionCost: 'Distribution costs',
  bonusCostForMission: 'Bonus costs',
  permitCostForMission: 'Permit costs',
  printingCostForMission: 'Printing costs',
  missions: 'Missions',
  scans: 'Scans',
}

export const LIST_VIEW = {
  CAMPAIGN: 'campaign',
  MONTHLY: 'monthly',
}

export const MENU_ITEMS = {
  export: 'export',
  changeListView: 'changeListView',
}

export const STATUS_FILTER_OPTIONS = [
  {
    label: 'All',
    value: null,
  },
  { label: 'Active', value: STATUS_CAMPAIGN_ENUM_ACTIVE },
  { label: 'Completed', value: STATUS_CAMPAIGN_ENUM_COMPLETED },
  { label: 'Draft', value: STATUS_CAMPAIGN_ENUM_DRAFT },
]

export const OPPIZI_ADS_STATUS_FILTER_OPTIONS = [
  {
    label: 'All',
    value: null,
  },
  { label: 'Draft', value: CAMPAIGN_INTERNAL_STATUSES.DRAFT },
  { label: 'In review', value: CAMPAIGN_INTERNAL_STATUSES.IN_REVIEW },
  { label: 'Rejected', value: CAMPAIGN_INTERNAL_STATUSES.REJECTED },
  {
    label: 'Approved',
    value: [
      CAMPAIGN_INTERNAL_STATUSES.CODE_REVIEW,
      CAMPAIGN_INTERNAL_STATUSES.UPLOAD_CODES,
      CAMPAIGN_INTERNAL_STATUSES.UPLOAD_CODES_DECLINED,
      CAMPAIGN_INTERNAL_STATUSES.GENERATING_DIGITAL_PROOF,
      CAMPAIGN_INTERNAL_STATUSES.PENDING_DIGITAL_PROOF,
      CAMPAIGN_INTERNAL_STATUSES.PAYMENT,
    ],
  },
  { label: 'Active', value: CAMPAIGN_INTERNAL_STATUSES.ACTIVE },
  { label: 'Completed', value: CAMPAIGN_INTERNAL_STATUSES.COMPLETED },
]

export const STATUS_OPTIONS_PRIORITY = {
  [STATUS_CAMPAIGN_ENUM_DRAFT]: 1,
  [STATUS_CAMPAIGN_ENUM_ACTIVE]: 2,
  [STATUS_CAMPAIGN_ENUM_COMPLETED]: 3,
  [STATUS_CAMPAIGN_ENUM_ARCHIVE]: 4,
}

export const OPPIZI_ADS_INTERNAL_STATUS_OPTIONS_PRIORITY = {
  [CAMPAIGN_INTERNAL_STATUSES.DRAFT]: 1,
  [CAMPAIGN_INTERNAL_STATUSES.IN_REVIEW]: 2,
  [CAMPAIGN_INTERNAL_STATUSES.REJECTED]: 3,
  [CAMPAIGN_INTERNAL_STATUSES.GENERATING_DIGITAL_PROOF]: 4,
  [CAMPAIGN_INTERNAL_STATUSES.CODE_REVIEW]: 4,
  [CAMPAIGN_INTERNAL_STATUSES.UPLOAD_CODES]: 4,
  [CAMPAIGN_INTERNAL_STATUSES.UPLOAD_CODES_DECLINED]: 4,
  [CAMPAIGN_INTERNAL_STATUSES.PENDING_DIGITAL_PROOF]: 4,
  [CAMPAIGN_INTERNAL_STATUSES.PAYMENT]: 4,
  [CAMPAIGN_INTERNAL_STATUSES.ACTIVE]: 5,
  [CAMPAIGN_INTERNAL_STATUSES.COMPLETED]: 6,
}

export const STATUS_OPTIONS_PRIORITY_V2 = {
  'draft': 1,
  'in review': 2,
  'action required': 3,
  'approved': 4,
  'active': 5,
  'completed': 6,
}

export const SORTING_OPTIONS = [
  { label: 'Date', value: 'startDate' },
  { label: 'Status', value: 'status' },
  { label: 'Name', value: 'name' },
]
